// NATIVE
import * as React from 'react';


// INSTALLED 
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import VerifiedIcon from '@mui/icons-material/Verified';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


// CUSTOM 
import { SinDatos } from './generics/SinDatos';
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, Chip, FormControlLabel, FormGroup, Grid } from '@mui/material';
import { paddingCardsTables } from '../commons';







export const  DetalleModuloPemisosUsuario = (props:any) => {


  // REDUX 
  const { userPemissionsAssigned }:any  = useSelector( (state:any) => state.usersPermissions );





  const RenderChildren = ({ element, parentText, level = 1 }: any) => {
  return (
    <Accordion
      defaultExpanded
      disableGutters
      elevation={0}
      sx={{ ml: level * 2, borderLeft: "2px solid #eee", mb: 1 }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
            py: 0.5,
            minHeight: 35,
            backgroundColor: level === 1 ? 'grey.100' : 'transparent',
            borderBottom: level === 1 ? '1px solid #e0e0e0' : 'none',
            '& .MuiAccordionSummary-content': {
            margin: 0,
            },
        }}
        >
        <Typography
            sx={{
            color: level === 1 ? 'text.primary' : 'text.secondary',
            fontSize: level > 1 ? "0.85rem" : "1rem",
            fontWeight: level === 1 ? 600 : 400,
            letterSpacing: "0.3px",
            }}
        >
            {element.text}
        </Typography>
        </AccordionSummary>


      <AccordionDetails sx={{ pl: 1, py: 1 }}>
        {/* Header con chip */}
        <Typography variant="subtitle2" component="div" sx={{ mb: 1 }}>
          <Chip size="small" label={parentText} />
        </Typography>

        {/* Checkbox de módulo habilitado */}
        <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: "wrap"}}>
          

          {/* Acciones */}
          {['view', 'create', 'edit', 'delete', 'restore'].map((action) => (
            <FormGroup key={action}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={element.actions?.includes(action) || false}
                    name={`${action}_${element.slug}`}
                  />
                }
                label={action.charAt(0).toUpperCase() + action.slice(1)}
              />
            </FormGroup>
          ))}
        </Box>

        {/* Renderizar subchildrens recursivamente */}
        {element.childrens && element.childrens.length > 0 && (
          <Box sx={{ mt: 1 }}>
            {element.childrens.map((child: any, idx: number) => (
              <RenderChildren key={idx} element={child} parentText={element.text} level={level + 1} />
            ))}
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
};
  
  
  
 
  return (


    <Box sx={{ width: '100%' }}>
      <Grid size={{ xs: 12, sm: 12, md: 12 }}>
        <Card sx={{ marginTop: paddingCardsTables }}>
          <Box sx={{ width: '100%' }}>


            {

              userPemissionsAssigned.length > 0

              ?

    
              userPemissionsAssigned.map((item:any, index:any) => ( 

                

                <>
                  {
                    
                    item.childrens.length > 0 
                    ?
                      <Accordion key={index} sx={{ mt: 3, borderTop: 4, borderColor: '#192a56', borderRadius: 2, overflow: 'hidden', boxShadow: 3 }}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon sx={{ color: '#192a56' }} />}
                          sx={{ backgroundColor: '#f0f4f8' }}
                        >
                          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography component="div" variant="h6" sx={{ color: '#192a56', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}>
                              {item.text} <VerifiedIcon fontSize="small" />
                            </Typography>
                            <Typography variant="body2" component="div" sx={{ color: 'text.secondary' }}>
                              Sub módulos y permisos
                            </Typography>
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: '#ffffff', padding: 2 }}>
                          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            
                            {/* Permisos del módulo padre */}
                            <Box sx={{ pl: 2, pb: 1 }}>
                                <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox  checked={item.isChecked} name={`mod_${item.permission_slug}`} />}
                                    label="Módulo habilitado"
                                />
                                </FormGroup>
                            </Box>

                            {/* Render de los children */}
                            <div>
                                {item.childrens.map((element: any, indexf: number) => (
                                <RenderChildren key={indexf} element={element} parentText={item.text} />
                                ))}
                            </div>
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    :
                    ''
                  }
                   
   
                   
                </>
                
              ))

              :
               <SinDatos/>

            }

          </Box>
        </Card>
      </Grid>
    </Box>
    
  );
}